<template>
  <!-- <PostLoginHeader :app_token="app_token" /> -->
  <main id="full-height-main" class="h-100">
    <div class="modal-tom" v-if="showResetCodeModal">
      <ResetPassword @togglePasswordResetModal="togglePasswordResetModal" :prefillEmail="prefillResetEmail" :prefillCode="prefillResetCode" />
    </div>
    <div class="modal-tom" v-if="showEmailCodeModal">
      <EmailConfirmation @emailConfirmed="emailConfirmed" :email="user_attr?.email" />
    </div>
    <div class="modal-tom" v-if="showMicrosoftErrorModal">
      <MicrosoftErrorModal @close="showMicrosoftErrorModal = false" :me="microsoftMe"></MicrosoftErrorModal>
    </div>
    <div class="d-flex justify-content-center flex-wrap h-100" id="body">
      <div class="col-12 col-md-4 d-flex flex-column justify-content-evenly align-items-center h-100 p-lg-5 p-0  border-right " >
        <div class="d-flex flex-column align-items-center w-100">
          <img src="crimetimelogowhitebg.svg" alt="logo" class="w-50 mb-5 pc-5" />
          <div class="d-flex flex-column justify-content-start border card border-radius-1 w-75">
            
            <div class="card-header section-header fw-bold d-flex justify-content-center fw-bold modal-header pl-5">
              Log In
            </div>
            <div class="card-body d-flex flex-column p-5">
              <form @submit.prevent="handleSubmit">
                <div class="">
                  <div class="form-group d-flex flex-column">
                    <h3 class="fs-5 fw-bold">Email Address</h3>
                    <input v-model="username" type="email" class="form-control form-control-lg fs-5 w-100" placeholder="Enter email" />
                    <small class="form-text text-muted pt-2 pb-2">
                      We will never share your email with anyone.
                    </small>
                  </div>
  
                  <div class="form-group mb-0 fs-4 d-flex flex-column">
                    <h3 class="fs-5 fw-bold">Password</h3>
                    <div class="d-flex w-100 p-0">
                      <input v-model="password" :type="revealPassword ? 'text' : 'password'" class="form-control form-control-lg fs-5 col-10 " placeholder="Password" />
                      <span class="form-control form-control-lg d-flex justify-content-center clickable btn-outline btn align-items-center fs-5 col-2 p-0" @click="revealPassword = !revealPassword">
                        <i class="fa fa-eye" @mouseup="revealPassword = false" @mousedown="revealPassword = true"></i>
                      </span>
                    </div>
                  </div>
  
                  <div class="d-flex flex-column">
                    <span class="clickable blue mb-3 fs-5" style="text-decoration: none" @click="togglePasswordResetModal">Reset Password</span>
                    <div class="d-flex flex-wrap align-items-center justify-content-center">
                      <div>
                        <button @keydown.enter="handleSubmit" @click="handleSubmit" v-if="!loading" class="btn btn-primary ">
                          Log In
                        </button>
                        <LoadingButton v-else ></LoadingButton>
                      </div>
                      <svg @click="useOAuth = !useOAuth" xmlns="http://www.w3.org/2000/svg" width="95" height="48" viewBox="0 0 104 41" class=" ml-3">
                        <title>MS-SymbolLockup</title>
                        <rect width="104" height="41" fill="#fff" />
                        <path d="M103,1V40H1V1H103m1-1H0V41H104V0Z" fill="#8c8c8c" />
                        <rect x="13" y="11" width="9" height="9" fill="#f25022" />
                        <rect x="13" y="21" width="9" height="9" fill="#00a4ef" />
                        <rect x="23" y="11" width="9" height="9" fill="#7fba00" />
                        <rect x="23" y="21" width="9" height="9" fill="#ffb900" />
                        <path d="M45.812,25.082V23.288a2.849,2.849,0,0,0,.576.4,4.5,4.5,0,0,0,.707.3,5.513,5.513,0,0,0,.747.187,3.965,3.965,0,0,0,.688.065,2.937,2.937,0,0,0,1.637-.365,1.2,1.2,0,0,0,.538-1.062,1.16,1.16,0,0,0-.179-.649,1.928,1.928,0,0,0-.5-.5,5.355,5.355,0,0,0-.757-.435q-.437-.209-.935-.436c-.356-.19-.687-.383-1-.578a4.358,4.358,0,0,1-.8-.648,2.728,2.728,0,0,1-.534-.8,2.6,2.6,0,0,1-.194-1.047,2.416,2.416,0,0,1,.333-1.285,2.811,2.811,0,0,1,.879-.9,4.026,4.026,0,0,1,1.242-.528,5.922,5.922,0,0,1,1.42-.172,5.715,5.715,0,0,1,2.4.374v1.721a3.832,3.832,0,0,0-2.3-.645,4.106,4.106,0,0,0-.773.074,2.348,2.348,0,0,0-.689.241,1.5,1.5,0,0,0-.494.433,1.054,1.054,0,0,0-.19.637,1.211,1.211,0,0,0,.146.608,1.551,1.551,0,0,0,.429.468,4.276,4.276,0,0,0,.688.414c.271.134.584.28.942.436q.547.285,1.036.6a4.881,4.881,0,0,1,.856.7,3.015,3.015,0,0,1,.586.846,2.464,2.464,0,0,1,.217,1.058,2.635,2.635,0,0,1-.322,1.348,2.608,2.608,0,0,1-.868.892,3.82,3.82,0,0,1-1.257.5,6.988,6.988,0,0,1-1.5.155c-.176,0-.392-.014-.649-.04s-.518-.067-.787-.117a7.772,7.772,0,0,1-.761-.187A2.4,2.4,0,0,1,45.812,25.082Z" fill="#5e5e5e" />
                        <path d="M55.129,16.426a1.02,1.02,0,0,1-.714-.272.89.89,0,0,1-.3-.688.916.916,0,0,1,.3-.7,1.008,1.008,0,0,1,.714-.278,1.039,1.039,0,0,1,.732.278.909.909,0,0,1,.3.7.9.9,0,0,1-.3.678A1.034,1.034,0,0,1,55.129,16.426Zm.842,9.074h-1.7V18h1.7Z" fill="#5e5e5e" />
                        <path d="M65.017,24.9q0,4.131-4.153,4.131a6.187,6.187,0,0,1-2.556-.491V26.986a4.726,4.726,0,0,0,2.337.7,2.342,2.342,0,0,0,2.672-2.628V24.24h-.029a2.947,2.947,0,0,1-4.742.436,4.041,4.041,0,0,1-.838-2.684,4.738,4.738,0,0,1,.9-3.04,3,3,0,0,1,2.476-1.128,2.384,2.384,0,0,1,2.2,1.216h.029V18h1.7Zm-1.684-2.835v-.973a1.91,1.91,0,0,0-.524-1.352A1.718,1.718,0,0,0,61.5,19.18a1.793,1.793,0,0,0-1.512.714,3.217,3.217,0,0,0-.546,2,2.774,2.774,0,0,0,.524,1.769,1.678,1.678,0,0,0,1.387.662,1.805,1.805,0,0,0,1.429-.632A2.391,2.391,0,0,0,63.333,22.064Z" fill="#5e5e5e" />
                        <path d="M73.908,25.5h-1.7V21.273q0-2.1-1.486-2.1a1.622,1.622,0,0,0-1.282.582,2.162,2.162,0,0,0-.5,1.469V25.5H67.229V18h1.707v1.245h.029A2.673,2.673,0,0,1,71.4,17.824a2.265,2.265,0,0,1,1.868.795,3.57,3.57,0,0,1,.644,2.3Z" fill="#5e5e5e" />
                        <path d="M80.962,16.426a1.02,1.02,0,0,1-.714-.272.89.89,0,0,1-.3-.688.916.916,0,0,1,.3-.7,1.008,1.008,0,0,1,.714-.278,1.039,1.039,0,0,1,.732.278.909.909,0,0,1,.3.7.9.9,0,0,1-.3.678A1.034,1.034,0,0,1,80.962,16.426ZM81.8,25.5H80.1V18h1.7Z" fill="#5e5e5e" />
                        <path d="M90.7,25.5H89V21.273q0-2.1-1.486-2.1a1.622,1.622,0,0,0-1.282.582,2.157,2.157,0,0,0-.506,1.469V25.5H84.023V18H85.73v1.245h.03a2.673,2.673,0,0,1,2.431-1.421,2.265,2.265,0,0,1,1.868.795,3.57,3.57,0,0,1,.644,2.3Z" fill="#5e5e5e" />
                      </svg>
                    </div>
                  </div>
                  <!-- <span class="error" v-if="errorMessage?.length > 0">{{
                    errorMessage
                  }}</span> -->
                </div>
              </form>
            </div>
            <span class="error" v-if="errorMessage">{{ errorMessage }}</span>
            <div v-if="useOAuth">
              <OAuth @microsoftOAuth="microsoftOAuth" @error="useOAuth = false; errorMessage = 'Microsoft sign-in failed. Please try again.'" />
            </div>
  
          
            <!-- <div class="fw-bold fw-bold card-header section-header mt-5" >Sign Up</div> -->
            
          </div>
          <div class=" d-flex justify-content-between mt-5 align-items-center w-75 px-5">
            <h3 class="form-group ">First time using CrimeTime?</h3>
  
            <router-link to="/getstarted/individual">
              <button class="btn btn-primary fs-5">
               Get Started <i class="fa fa-arrow-right pl-2"></i>
              </button>
            </router-link>
          </div>
        </div>
        <div></div>

        
      </div>
      <div class="col-12 col-md-8 p-0 tab-hidden">
        <!-- <div style="width: 50px; height: 100px;" class="clickable d-flex align-items-center justify-content-center" @click="cycleLeft">
              <i class="fa fa-chevron-left" ></i>
            </div> -->
        <LoginHero />
        <article class="w-100 hidden">
          <div class="d-flex align-items-start justify-content-between" v-if="mode == 'getStarted'">
            <div class="d-flex flex-column align-items-center col-12">
              <h1 class="fw-bold fs-1 mb-5">
                Criminal Sentencing, <span class="blue">Simplified.</span>
              </h1>
              <p class="fs-3">
                For over 20 years, attorneys, judges, probation departments, and law
                enforcement have been trusting CrimeTime to trivialize criminal
                sentencing, and you can too!
              </p>
              <p class="fs-3">
                With CrimeTime, calculating sentences has never been easier! To get
                started, simply make and name a case, add your charges from our database
                of over 7,000 crimes, and calculate every lawful scenario with our
                powerful software.
              </p>
              <p class="fs-3">
                Once you've reached the right settings, you can save and download your
                data into a client-ready PDF report that comes ready to bring to trial.
              </p>
              <p class="fs-3 mb-5">
                Try it yourself with our no-commitment 30 day free trial!
              </p>
              <div>
                <button class="btn btn-primary btn-xl">
                  Sign Up <i class="fa fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="p-5 " >
            <div class="">
              <h1 class="card-header section-header fw-bold">What's New in CrimeTime?</h1>
            </div>
            <div class="card-body d-flex flex-wrap pt-3">
              <div class="d-flex align-items-center flex-wrap col-12 col-lg-11 p-0">
              
                <div class="d-flex flex-column col-12 col-lg-6 px-2" >
                  <div class="fw-bold fs-3">
                    <i class="fa fa-chevron-right btn-color mr-3 fw-bold fs-4"></i>
                    Updated Probation Module
                  </div>
                  <p class="fs-5 py-3">Generate customizable case eligibility for probation, apply limitations and create detailed reports outlining probation conditions.</p>
                  <div class="fw-bold fs-3">
                    <i class="fa fa-chevron-right btn-color mr-3 fw-bold fs-4"></i>
                    New Circumstances Module
                  </div>
                  <p class="fs-5 py-3">Users can now add case-specific mitigating and aggravating circumstances and generate comprehensive reports that reference applicable statutes and circumstances.</p>
                </div>
                <div class="d-flex flex-column col-12 col-lg-6 px-2">
                  <div class="fw-bold fs-3">
                    <i class="fa fa-chevron-right btn-color mr-3 fw-bold fs-4"></i>
                    Single Search <i class="fa fa-arrow-right mx-3"></i> Crime Search
                  </div>
                  <p class="fs-5 py-3">The updated Crime Search tool allows users to quickly access clear and concise crime information using the new filters that include additional resources like Jury Instructions.</p>
                  <div class="fw-bold fs-3">
                    <i class="fa fa-chevron-right btn-color mr-3 fw-bold fs-4"></i>
                    New Administrator Settings
                  </div>
                  <p class="fs-5 py-3">County administrators can now implement extra security features, manage user roles and disable Personal Identifying Information when creating cases.</p>
                </div>
              </div>
            </div>
          </div>
        </article>
        <!-- <div style="width: 50px; height: 100px;" @click="cycleRight" class="clickable d-flex align-items-center justify-content-center" >
            <i class="fa fa-chevron-right" ></i>
            </div> -->
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import fetch from "node-fetch";
// import fs from "fs";
//import dotenv from "dotenv";
import SC from "../../components/utils/sharedComponent.vue";
import { resolveLandingRoute, storeModuleAccess, getStoredModuleAccess } from "../../moduleAccess.js";
import ResetPassword from "../Profile/ResetPassword.vue";
import EmailConfirmation from "../Profile/EmailConfirmation.vue";
import OAuth from "./OAuth.vue";
import PostLoginHeader from "./PostLoginHeader.vue";
import MicrosoftErrorModal from "./MicrosoftErrorModal.vue";
// import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3'
// const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
import LoginHero from "./LoginHero.vue";
import LoadingButton from "../../components/utils/LoadingButton.vue";
import { handleError } from "../../helpers";
export default {
  name: "Cases",
  data() {
    return {
      modes: ["getStarted", "crimeFinder", "juryInstructions"],
      mode: "juryInstructions",
      username: "",
      password: "",
      authorized: false,
      token: "",
      tries: 0,
      user_attr: null,
      showResetCodeModal: false,
      prefillResetEmail: "",
      prefillResetCode: "",
      showEmailCodeModal: false,
      invalidToken: true,
      phone: { areaCode: "", mid: "", last4: "" },
      smsTokenPhone: "",
      tokenInfo: { data: {} },
      errorMessage: null,
      siteUrl: process.env.VUE_APP_URL,
      revealPassword: false,
      useOAuth: false,
      showMicrosoftErrorModal: false,
      microsoftMe: null,
      organizationSettings: {},
      loading: false,
    };
  },
  components: {
    ResetPassword,
    EmailConfirmation,
    OAuth,
    PostLoginHeader,
    MicrosoftErrorModal,
    LoginHero,
    LoadingButton
  },
  methods: {
    cycleLeft() {
      let index = this.modes.indexOf(this.mode);
      if (index == 0) {
        this.mode = this.modes[this.modes.length - 1];
      } else {
        this.mode = this.modes[index - 1];
      }
    },
    cycleRight() {
      let index = this.modes.indexOf(this.mode);
      if (index == this.modes.length - 1) {
        this.mode = this.modes[0];
      } else {
        this.mode = this.modes[index + 1];
      }
    },
   
    toggleDarkMode() {
      const theme = localStorage.getItem("theme");
      if (theme !== "Toms Theme") {
        localStorage.setItem("theme", "Toms Theme");
      } else {
        localStorage.setItem("theme", "Placer Group");
      }
      window.location.href = "/login";
    },

    async microsoftOAuth(token, idToken) {
      // console.log(token);
      this.useOAuth = false;
      // const body = await axios
      //   .post(process.env.VUE_APP_ENDPOINT + "/api/prepareMicrosoftToken", {
      //     token: token,
      //   })
      //   .then(async (res) => {
      //     console.log(res);
      //     const msToken = res.data.token;
      //Checks if the token is valid
      const me = await axios
        .post(process.env.VUE_APP_ENDPOINT + "/api/microsoft/me", {
          token: token,
        })
        .then((results) => {
          // console.log(results);
          if (results?.data?.me) {
            return results?.data?.me;
          } else {
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          return false;
        });
      // console.log(me);
      this.microsoftMe = me;
      const validatedToken = await axios
        .post(process.env.VUE_APP_ENDPOINT + "/api/authenticateMicrosoftToken", {
          token: token,
          idToken: idToken,
        })
        .then(async (result) => {
          if (result) {
            // console.log(result?.data?.foundMSUser?.MicrosoftId);
            if (result?.data?.foundMSUser?.MicrosoftId == me?.id) {
              const authToken = await axios
                .post(process.env.VUE_APP_ENDPOINT + "/api/loginWithMicrosoftToken", {
                  // The server verifies the ID token (issued to our app) and the matching Graph user.
                  token: token,
                  idToken: idToken,
                })
                .then((grantedAuthToken) => {
                  if (grantedAuthToken) {
                    localStorage.setItem("user_token", grantedAuthToken?.data?.token);
                    localStorage.setItem("user_key", grantedAuthToken?.data?.key);
                    localStorage.setItem(
                      "user_attr",
                      JSON.stringify(grantedAuthToken?.data?.user_attr)
                    );
                    storeModuleAccess(grantedAuthToken?.data?.moduleAccess);
                    // this.$emit("params", {
                    //   user_token: grantedAuthToken?.data?.token,
                    //   user_attr: grantedAuthToken?.data?.user_attr,
                    //   user_subscription_status:
                    //     grantedAuthToken?.data?.subscriptionStatus,
                    // });
                    this.$router.push(resolveLandingRoute(grantedAuthToken?.data?.moduleAccess));
                  }
                })
                .catch((e) => {
                  console.error(e);
                  // e.g. 401 "User is locked out"
                  this.errorMessage = e?.response?.data?.message || "Microsoft sign-in failed. Please try again.";
                });
            } else {
              // console.log("MISMATCH");
              this.errorMessage = "Microsoft sign-in failed. Please try again.";
            }
          }
        })
        .catch((e) => {
          // console.log(e);
          const res = e.response;
          // console.log(me);
          // Only 404 means "no CrimeTime account linked"; 401/500/503 are sign-in or outage errors.
          if (res?.status == 404) {
            this.showMicrosoftErrorModal = true;
          } else {
            this.errorMessage = res?.data?.message || "Microsoft sign-in failed. Please try again.";
          }
          
        });
      // })
      // .catch((e) => console.log(e));
    },

    async submitLogin(body) {
      // this.$recaptcha("login").then((captchaToken) => {
      //   // console.log('CAPTCHA TOKEN', captchaToken)
      // });
      this.loading = true;
      const res = await axios
        .post(process.env.VUE_APP_ENDPOINT + "/api/auth/login", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((data) => {
          if (data?.data?.authorized == true) {
            localStorage.setItem("user_token", data?.data?.token);
            localStorage.setItem("user_key", data?.data?.key);
            localStorage.setItem("user_attr", JSON.stringify(data?.data?.user_attr));
            storeModuleAccess(data?.data?.moduleAccess);

            this.token = data?.data?.token;
            this.user_attr = data?.data?.user_attr;

            // this.$emit("params", {
            //   user_token: this.token,
            //   user_attr: data?.data?.user_attr,
            //   user_subscription_status: data?.data?.subscriptionStatus,
            // });
            this.loading = false;
            this.$router.push(resolveLandingRoute(data?.data?.moduleAccess));
          }
        })
        .catch((err) => {
          // console.error(err);
          // let error = err.response;
          // // console.log(err.response);
          // const data = err.response?.data;
          // if (err?.response?.status == 401) {
          //   this.errorMessage = "Invalid Login Credentials";
          // } else if (err?.response?.status == 429) {
          //   this.errorMessage =
          //     "Too many login attempts. Please try again later or contact us at support@placergroup.com";
          // } else if (err?.response?.status == 404) {
          //   console.log("404");
          //   this.errorMessage = "Account not found.";
          // } else {
          //   this.errorMessage = "An error occurred. Please try again later.";
          // }
          console.error(err)
          this.errorMessage = handleError(err);
          this.loading = false;

          // Handles various states of disarray

          // if (err.response.status == 402) {
          //   console.log('402')
          //   localStorage.setItem("user_token", data?.token);
          //   localStorage.setItem("user_attr", JSON.stringify(data?.user_attr));
          //   localStorage.setItem("subscription_status", data?.subscriptionStatus);
          //   if(data?.subscriptionStatus === 'Expired' || data?.subscriptionStatus === 'Canceled'){
          //     window.location.href = "/ReactivateSubscription";
          //   }
          //   console.log('subscription status: ', data?.subscriptionStatus)
          //   window.location.href = "/ReactivateSubscription";
          // } else {

          // }
        });
        this.loading = false;
    },

    handleSubmit(e) {
      e.preventDefault();

      let body = { username: this.username, password: this.password };

      if (this.username?.length > 3 && this.password?.length > 0) {
        // Check if user.TwoFactorEnabled is false
        // if (!user.TwoFactorEnabled) {
        this.checkUserTwoFactorAuth = false;
        this.submitLogin(body);
        // }
      }
    },

    togglePasswordResetModal() {
      // console.log('bong')
      this.showResetCodeModal = !this.showResetCodeModal;
    },
    async checkCredentials() {
      // console.log("uuid:", SC.deviceUUID());

      try {
        let token = localStorage.getItem("user_token");
        if (token == "" || token === undefined || token == null || token?.length == 0) {
          return false
        };

        let body = { user_token: token, source: 'loginMountFunction' };
        await axios
          .post(process.env.VUE_APP_ENDPOINT + "/api/auth/checkcredentials", body, {
            headers: { Authorization: `Bearer ` + token },
          })
          .then((data) => {
            data = data.data;
            // console.log("datadatadata:", data);

            if (data.authorized == true) {
              localStorage.setItem("user_token", data.token);
              localStorage.setItem("user_key", data.key);
              localStorage.setItem("subscription_status", data.subscription_status);
              this.token = data.token;

              //this.$emit("user_token", this.token)
              // this.$emit("params", {
              //   user_token: this.token,
              //   user_attr: data.user_attr,
              //   user_subscription_status: data.subscription_status,
              // });
              this.$router.push(resolveLandingRoute(getStoredModuleAccess()));
            }
          })
          .catch((error) => {
            console.error(error.response);
            handleError(error);
            // if (!this.user_attr) {
            //   this.user_attr = JSON.parse(localStorage.getItem("user_attr"));
            // }
            // // console.log(this.user_attr)

            // // this.user_attr = error.response?.data?.foundUser
            // this.errorMessage = error.response?.data?.message;
            // if (error.response.status == 402 && this.user_attr?.id) {
            //   localStorage.setItem("user_token", data.token);
            //   localStorage.setItem("user_attr", JSON.stringify(data.user_attr));
            //   localStorage.setItem("subscription_status", data.subscription_status);
            //   if (
            //     data?.subscriptionStatus === "Expired" ||
            //     data?.subscriptionStatus === "Canceled"
            //   ) {
            //     window.location.href = "/ReactivateSubscription";
            //   }
            //   // console.log("subscription status: ", data?.subscriptionStatus);
            //   window.location.href = "/createSubscription";
            // } else if (error.response.status == 401) {
            //   localStorage.removeItem("user_token");
            //   localStorage.removeItem("user_attr");
            //   localStorage.removeItem("subscription_status");
            //   // this.errorMessage = "Invalid Login Credentials";
            // } else if (error.response.status == 410) {
            //   window.location.href = "/error?code=410";
            // }
          });
      } catch (e) {
        console.error(e);
        handleError(e);
      }
    },
    async startEmailValidation() {
      this.showEmailCodeModal = true;
      const createdCode = await axios.post(
        process.env.VUE_APP_ENDPOINT +
          `/api/registration/createEmailValidation/${this.user_attr?.id}`
      );
    },
    async emailConfirmed() {
      this.showEmailCodeModal = false;
      this.checkCredentials();
    },

    async fetchOrganizationSettings() {
      try {
        const response = await axios.get(
          process.env.VUE_APP_ENDPOINT + "/api/org/fetchOrganizationSettings",
          {
            headers: {
              Authorization: `Bearer ` + localStorage.getItem("user_token"),
            },
          }
        );
        this.organizationSettings = response.data?.organizationSettings;
        this.setSessionLifespan();
        // console.log('Organization Settings:', this.organizationSettings);
      } catch (error) {
        console.error('Error fetching organization settings:', error);
      }
    },

  },

  mounted() {
    // Open the set-password modal automatically when arriving from an emailed
    // student invite link (/login?resetEmail=...&resetCode=...).
    const q = this.$route?.query || {};
    if (q.resetCode) {
      this.prefillResetEmail = q.resetEmail || "";
      this.prefillResetCode = q.resetCode || "";
      this.showResetCodeModal = true;
    }
    this.checkCredentials();
    // this.fetchOrganizationSettings();
  },
};
</script>

<style scoped>

.card-border {
  border-radius: 10px;
  /* border: 1px solid #771212; */
}

.vh-100 {
  height: 100vh;
  max-height: 85vh;
}

#body {
  min-height: 82vh;
}





.clickable:hover {
  cursor: pointer;
}

.blue {
  color: blue !important;
  text-decoration: underline;
}

.password-btn {
  background-color: var(--light) !important;
  background: transparent;
}
.no-br-r {
  border-radius: 0 5% 5% 0 !important;
}
.error {
  color: red;
  text-align: center;
  padding: 10px;
  font-size: 1rem;
}

.h-100 {
  height: 100% !important;
  min-height: 100% !important;
}
#logo-image {
  min-width: 350px !important;
}

.blue {
  color: var(--button) !important;
  text-decoration: none;
}



.btn-color {
  color: var(--button) !important;
}


.btn-lg {
  border-radius: 10px;
}
#full-height-main {
  height: 100vh !important;
  max-height: 100vh !important;
  padding: 0; 
  margin: 0;
  width: 100vw !important;
  max-width: 100vw !important;
}
</style>
